import React, { useState } from 'react'
import formatIndianNumber from '../helper/Helper'

const CustomTable = ({ data = [] }) => {
    const [sortedData, setSortedData] = useState(data)

    const generateColumns = (data) => {
        if (data?.length === 0) return []

        const keys = [...new Set(data.flatMap(Object.keys))]

        return keys?.map(key => ({
            title: key
                ?.replace(/^xAxis_|^yAxis_/, '')
                ?.replace(/_/g, ' ')
                ?.replace(/\b\w/g, char => char.toUpperCase()),
            dataIndex: key,
            key: key,
        }))
    }

    const handleSort = (key) => {
        const sorted = [...sortedData]
        const isAscending = sorted[0][key] > sorted[1]?.[key]

        sorted.sort((a, b) => {
            if (typeof a[key] === 'string') {
                return isAscending
                    ? a[key].localeCompare(b[key])
                    : b[key].localeCompare(a[key])
            } else if (typeof a[key] === 'number') {
                return isAscending ? a[key] - b[key] : b[key] - a[key]
            }
            return 0
        })

        setSortedData(sorted)
    }

    const columns = generateColumns(data)

    return (
        <>
            <style>
                {`
                    table {
                        width: 100%;
                        border-collapse: collapse;
                        background-color: #1c1c1c;
                        max-height: 90vh;
                        overflow-y: auto;
                        display: block;
                        margin-top: 40px;
                    }
                    th, td {
                        width: 100%;
                        padding: 12px;
                        border: 1px solid #3f3f3f;
                        text-align: left;
                        color: white;
                    }
                    th {
                        background-color: #2f2f2f;
                        cursor: pointer;
                    }
                    tr:hover {
                        background-color: #242424;
                    }
                `}
            </style>

            <table>
                <thead>
                    <tr>
                        {columns.map((col) => (
                            <th
                                key={col.key}
                                onClick={() => handleSort(col.key)}
                                className="sortable"
                            >
                                {col.title}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {sortedData.length === 0 ? (
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: 'center' }}>
                                No Data Available
                            </td>
                        </tr>
                    ) : (
                        sortedData.map((row, index) => (
                            <tr key={index}>
                                {columns.map((col) => (
                                    <td key={col.key}>
                                        {typeof row[col.key] === 'number'
                                            ? formatIndianNumber(row[col.key])
                                            : row[col.key]}
                                    </td>
                                ))}
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </>
    )
}

export default CustomTable